import { useNavigate } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import SocieteAndUserService from "../../../services/societeAndUser";

import uploadAndDownloadService from "../../../services/uploadAndDownloadFile";
import SocieteInformation from "../../../ui/SocieteInformation";
import ClientSocieteTable from "./ClientSocieteTable";
import ClientGroupeTable from "./ClientGroupeTable";
import getCurrentUserId from "../../../reduxSaga/sagas/requests/currentUserId";
import ZoneTable from "./ZoneTable";
import ZoneService from "../../../services/Zone";
import withLoader from "../../../components/layouts/WithLoader";

const ZoneSociete = ({ startLoading, stopLoading }) => {
  const navigate = useNavigate();
  const [zones, setZones] = useState([]);
  const [informationModel, setInformationModel] = useState();
  const [onShowInformationModel, setOnShowInformationModel] = useState(false);
  useEffect(() => {
    const fetchZone = async () => {
      try {
        startLoading();
        const response = await ZoneService.getZonesById(getCurrentUserId());
        console.log(response.data);
        setZones(response.data.success);
      } catch (error) {
        console.error('Error fetching zone:', error);
      } finally {
        stopLoading();
      }
    };

    fetchZone();
  }, []);


  const onAddSocieteHandler = () => {
    navigate(`/ajouterzone`);
  };
  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <div className="content ">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-12">
              <div class="card  mt-3">
                <div class="card-body">
                  <h5 class="card-title">Ajouter une Zone</h5>
                  <button
                    class="btn btn-dark float-right"
                    onClick={onAddSocieteHandler}
                  >
                    <i class="fas fa-plus"></i>
                  </button>
                </div>

              </div>
              <ZoneTable listZones={zones} />


            </div>
          </div>
        </div>
      </div>

      {onShowInformationModel && (
        <SocieteInformation
          setOnShowInformationModel={setOnShowInformationModel}
          informationModel={informationModel}
        />
      )}
    </div>
  );
};
export default withLoader(ZoneSociete);
